const { registerPaymentMethod } = window.wc.wcBlocksRegistry

import RevolutGatewayBlock from './blocks/card-field'
import RevolutPayBlock from './blocks/revolut-pay'

registerPaymentMethod(RevolutGatewayBlock)
registerPaymentMethod(RevolutPayBlock)
